import React from 'react';
import { Locale } from "../../assets/Locale";

import "./App.scss";
import { Modal } from '@randajan/jet-react/dom/modal';
import { useBeam } from '@randajan/bifrost/client/react';
import { localeBeam } from '../../assets/beams/localeBeam';
import { Gateway } from './GateWay/Gateway';

export const App = (props)=>{
    const { data:say, status } = useBeam(localeBeam);

    
    return (
        <Locale.Provider value={say}>
            <Modal className="App" closeOnBlur>
                <Gateway status={status}/>
            </Modal>
        </Locale.Provider>
    )
}

